/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


export const $GuardianAlertHistoryIndexRequest = {
    properties: {
        guardianAlertHistoryId: {
            type: 'number',
        },
        timeRangePreset: {
            type: 'TimeRangePresets',
        },
        startUpdatedTs: {
            type: 'Date',
            format: 'date-time',
        },
        endUpdatedTs: {
            type: 'Date',
            format: 'date-time',
        },
        alertType: {
            type: 'AlertType',
        },
        page: {
            type: 'number',
        },
        pageSize: {
            type: 'number',
            minimum: 1,
        },
    },
};